var jCube = require('./jCube/core');

require('./jCube/class'),
require('./jCube/elements'),
require('./jCube/events'),
require('./jCube/is'),
require('./jCube/data'),
require('./jCube/ajax'),
require('./jCube/uri'),
require('./jCube/strings'),
require('./jCube/helpers');

module.exports = jCube;
